import {
    FILE_UPLOAD,
    FILE_UPLOAD_ERROR,
    FILE_VERSIONS,
    FILE_VERSIONS_ERROR,
    DOCUMENT_COMMENTS,
    DOCUMENT_COMMENTS_ERROR,
    PO_NEW_VERSION_FILE_UPLOAD,
    PO_NEW_VERSION_FILE_UPLOAD_ERROR,
    FILE_UPLOAD_ADVANCED,
    FILE_UPLOAD_ADVANCED_ERROR,
} from '../type'
import axios from 'axios';
import swal from '@sweetalert/with-react';
import env from '../../ENV';
import toast from 'react-hot-toast';

const ROOT_URL = env.BACKEND_URL;
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

export const uploadFile = (files, StageDocumentId, id, lineitemid, stagePrimaryIds) => async dispatch => {
    if (files.length < 1) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: "No file",
        })
        return false;
    }
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        return fi
    });
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/0/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        console.log("resp", res.data)

        if ('results' in res.data) {
            Object.values(res.data.results).forEach(async (item, index) => {
                let stageDocId = StageDocumentId && StageDocumentId.length > 0 && StageDocumentId[index] ? StageDocumentId[index] : "";
                let stageId = stagePrimaryIds && stagePrimaryIds.length > 0 && stagePrimaryIds[index] ? stagePrimaryIds[index] : "";
                await axios.post(`${ROOT_URL}po/${id}/lineitems/${lineitemid}/documents`, {
                    stageDocumentId: stageDocId,
                    uploadId: item.DocumentId,
                    stageId: stageId
                })
            })
        }
        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}

export const uploadFileforPOAcceptance = (files, StageDocumentId, id, lineitemid, stagePrimaryIds) => async dispatch => {
    if (files.length < 1) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: "No file",
        })
        return false;
    }
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        return fi
    });
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/0/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })

        console.log("resp", res.data)

        // if ('results' in res.data) {
        //     Object.values(res.data.results).forEach(async (item, index) => {
        //         let stageDocId = StageDocumentId && StageDocumentId.length > 0 && StageDocumentId[index] ? StageDocumentId[index] : "";
        //         let stageId = stagePrimaryIds && stagePrimaryIds.length > 0 && stagePrimaryIds[index] ? stagePrimaryIds[index] : "";
        //         await axios.post(`${ROOT_URL}po/${id}/lineitems/${lineitemid}/documents`, {
        //             stageDocumentId: stageDocId,
        //             uploadId: item.DocumentId,
        //             stageId: stageId
        //         })
        //     })
        // }
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })
        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        return res.data

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}


export const downloadFile = (documentId) => async dispatch => {

    try {
        const res = await axios({
            method: 'get',
            url: `${FILESERVER_ROOT_URL}files/Documents/${documentId}/download`
        })
        console.log("resp", res.data)
        const url = window.URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', res.headers["content-disposition"].split("filename=")[1]);
        document.body.appendChild(link);
        link.click();

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}

export const getDocumentVersions = (documentId) => async dispatch => {

    try {
        const res = await axios({
            method: 'get',
            url: `${FILESERVER_ROOT_URL}files/Documents/${documentId}/versions`
        })
        console.log("resp", res.data)
        dispatch({
            type: FILE_VERSIONS,
            payload: res.data
        })
    } catch (e) {
        dispatch({
            type: FILE_VERSIONS_ERROR,
            payload: console.log(e),
        })
    }

}


export const uploadInspectionFiles = (files, documentTypeIds, inspectionCallId) => async dispatch => {
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        return fi
    })


    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/0/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        console.log("resp", res.data)
        var input = []

        if ('results' in res.data) {
            Object.values(res.data.results).forEach((item, index) => {
                let documentTypeId = documentTypeIds && documentTypeIds.length > 0 && documentTypeIds[index] ? documentTypeIds[index] : ""
                input.push({
                    inspectionCallId: inspectionCallId,
                    documentTypeId: documentTypeId,
                    documentUploadId: item.DocumentId
                })
            })

            console.log("documentMaps", input)

            await axios.post(`${ROOT_URL}inspection/${inspectionCallId}/documents`, {
                documentMaps: input
            })
        }

        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}

export const uploadVersionFile = (files, StageDocumentId, id, lineitemid, stagePrimaryIds, versionUploadIds, comments, status, actedBy, qATemplateStageId) => async dispatch => {
    try {

        let res = {
            data: {}
        };

        for (let i = 0; i < files.length; i++) {
            let data = new FormData();
            data.append(`file-name`, files[i]);
            let uploadId = versionUploadIds[i]
            res = await axios({
                method: 'post',
                url: `${FILESERVER_ROOT_URL}files/uploadwversion/${uploadId}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            let comment = comments && comments.length > 0 ? comments[i] : "";
            let DocumentTypeId = StageDocumentId && StageDocumentId.length > 0 ? StageDocumentId[i] : "";
            let sta = status && status.length > 0 ? status[i] : 1;

            res = await axios({
                method: 'post',
                url: `${ROOT_URL}po/change-doc-status`,
                data: {
                    status: sta,
                    uploadId: uploadId,
                    comment: comment,
                    DocumentTypeId: DocumentTypeId,
                    actedBy: actedBy,
                    poId: id,
                    QATemplateStageId: qATemplateStageId
                }
            })
        }

        swal.close();
        swal("File have been uploaded", {
            icon: "success"
        });
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}

export const getComments = (documentId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${FILESERVER_ROOT_URL}files/Documents/${documentId}/comments`
        })

        dispatch({
            type: DOCUMENT_COMMENTS,
            payload: res.data
        })
    } catch (e) {
        dispatch({
            type: DOCUMENT_COMMENTS_ERROR,
            payload: console.log(e),
        })
    }
}

export const uploadPOVersionFile = (files, comment, uploadId, PodocumentId) => async dispatch => {
    try {

        let data = new FormData();
        data.append(`file-name`, files);
        let res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/uploadwversion/${uploadId}`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/update-po-document-comment`,
            data: {
                status: 1,
                uploadId: uploadId,
                comment: comment,
                PodocumentId: PodocumentId
            }
        })

        swal.close();
        swal("File have been uploaded", {
            icon: "success"
        });
        dispatch({
            type: PO_NEW_VERSION_FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: PO_NEW_VERSION_FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}

// export const uploadFile = (files, StageDocumentId, id, lineitemid, stagePrimaryIds) => async dispatch => {
/*export const uploadFileSub = (files) => async dispatch =>{
    let data = new FormData();
    data.append(`file-name`, files);
    try{
        const res = await axios({
                        method: 'post',
                        url: `${FILESERVER_ROOT_URL}files/upload`,
                        data: data,
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    })
        // res = await axios({
        //     method: 'post',
        //     url: `${ROOT_URL}po/update-po-document-comment`,
        //     data: {
        //             status: 1,
        //             // uploadId: uploadId,
        //             // comment: comment,
        //             PodocumentId: PodocumentId
        //         }
        // })
        swal.close();
        swal("File have been uploaded", {
        icon: "success"
        });
        dispatch( {
            type: FILE_UPLOAD_ADVANCED,
            payload: res.data
        })
    }
    catch(e){
        dispatch( {
            type: FILE_UPLOAD_ADVANCED_ERROR,
            payload: console.log(e),
        })
    }
}*/
export const uploadFileAdvance = (files, uploadId) => async dispatch => {

    // if (files.length < 1) {
    //     dispatch({
    //         type: FILE_UPLOAD_ADVANCED_ERROR,
    //         payload: "No file",
    //     })
    //     return false;
    // }
    // var data = new FormData();
    // files.map((fi, index) => {
    //     data.append(`file-${index}`, fi);
    //     data.append(`file-name`, fi);
    // });
    let data = new FormData();
    data.append(`file-name`, files);
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/uploadwversion/${uploadId}`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        console.log("resp", res.data)


        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        dispatch({
            type: FILE_UPLOAD_ADVANCED,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ADVANCED_ERROR,
            payload: console.log(e),
        })
    }

}

export const uploadFileforAdvanceDocuments = (files) => async dispatch => {
    if (files.length < 1) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: "No file",
        })
        return false;
    }
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        return fi
    });
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/0/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })

        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })
        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        return res.data

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}

export const uploadPaymentAcknowledgement = (files) => async dispatch => {
    if (files.length < 1) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: "No file",
        })
        return false;
    }
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        return fi
    });
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/0/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })

        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })
        swal.close();
        swal(res.data.message, {
            icon: "success"
        });
        return res.data

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}


// ? upload file for all
// ? For uploading Dispatch related documents by Supplier
export const uploadFileGeneric = (files, userID = 0, PaymentTypeId = 0) => async dispatch => {
    if (files.length < 1) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: "No file",
        })
        return false;
    }
    var data = new FormData();
    files.map((fi, index) => {
        // data.append(`file-${index}`, fi);
        data.append(`file-name`, fi);
        if (userID) {
            data.append(`userID`, userID)
        }
        return fi
    });
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/${PaymentTypeId}/upload`,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })

        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })
        toast.success(`Files have been uploaded`);

        return res.data

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }

}

// ? generic revise action
export const GenericUploadVersionFile = (files, versionUploadIds, comments, userID = 0) => async dispatch => {
    try {

        const res = {
            data: {}
        };

        console.log(files, versionUploadIds, comments, 'files action')

        for (let i = 0; i < files.length; i++) {
            let data = new FormData();
            data.append(`file-name`, files[i]);
            if (userID) {
                data.append(`userID`, userID)
            }
            let uploadId = versionUploadIds
            const res = await axios({
                method: 'post',
                url: `${FILESERVER_ROOT_URL}files/uploadwversion/${uploadId}`,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            // let comment = comments && comments.length > 0 ? comments[i] : "";
            // let DocumentTypeId = StageDocumentId && StageDocumentId.length > 0 ? StageDocumentId[i] : "";
            // let sta = status && status.length > 0 ? status[i] : 1;
            console.log('response from action ', res)
            // ! ? custom logic

            return res.data
        }
        // swal.close();
        // swal("File have been uploaded", {
        //     icon: "success"
        // });
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}
//generate DC
export const generateDispatchClearence = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${FILESERVER_ROOT_URL}files/generate-dc`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: FILE_UPLOAD,
            payload: res.data
        })

    } catch (e) {
        dispatch({
            type: FILE_UPLOAD_ERROR,
            payload: console.log(e),
        })
    }
}